import { render, staticRenderFns } from "./main.vue?vue&type=template&id=224e199a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=224e199a&prod&scoped=true&lang=less"
import style1 from "./main.vue?vue&type=style&index=1&id=224e199a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e199a",
  null
  
)

export default component.exports